import { ExternalLink, Smartphone } from "lucide-react";
import { useLang } from "@/lib/i18n";

const APPS = [
  {
    name: "Microsoft Authenticator",
    ios: "https://apps.apple.com/de/app/microsoft-authenticator/id983156458",
    android: "https://play.google.com/store/apps/details?id=com.azure.authenticator",
  },
  {
    name: "Google Authenticator",
    ios: "https://apps.apple.com/de/app/google-authenticator/id388497605",
    android: "https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2",
  },
];

/**
 * Direkte App-Store-/Play-Store-Links zu den gaengigen Authenticator-Apps.
 * dark: Darstellung auf dunklem Hintergrund (Enroll-Screen).
 */
export const AuthenticatorAppLinks = ({ dark = false }) => {
  const { t } = useLang();
  const cardCls = dark
    ? "rounded-[12px] border border-white/10 bg-white/[0.04] p-3"
    : "rounded-[12px] border border-border bg-muted/50 p-3";
  const nameCls = dark ? "text-sm font-medium text-white" : "text-sm font-medium";
  const linkCls = dark
    ? "inline-flex items-center gap-1 rounded-[8px] border border-white/15 bg-white/5 px-2.5 py-1.5 text-xs text-white/80 hover:bg-white/10 hover:text-white transition-colors"
    : "inline-flex items-center gap-1 rounded-[8px] border border-border bg-background px-2.5 py-1.5 text-xs text-foreground hover:bg-accent transition-colors";

  return (
    <div className="space-y-2" data-testid="authenticator-app-links">
      {APPS.map((app) => (
        <div key={app.name} className={cardCls}>
          <div className="flex items-center gap-2">
            <Smartphone className={dark ? "h-4 w-4 text-[#D6C08D]" : "h-4 w-4 text-[#BFA76A]"} />
            <span className={nameCls}>{app.name}</span>
          </div>
          <div className="mt-2 flex flex-wrap gap-2">
            <a href={app.ios} target="_blank" rel="noopener noreferrer" className={linkCls}
               data-testid={`app-link-ios-${app.name.toLowerCase().replace(/\s/g, "-")}`}>
              <ExternalLink className="h-3 w-3" /> App Store (iPhone)
            </a>
            <a href={app.android} target="_blank" rel="noopener noreferrer" className={linkCls}
               data-testid={`app-link-android-${app.name.toLowerCase().replace(/\s/g, "-")}`}>
              <ExternalLink className="h-3 w-3" /> Google Play (Android)
            </a>
          </div>
        </div>
      ))}
      <p className={dark ? "text-[11px] text-white/40" : "text-[11px] text-muted-foreground"}>
        {t("Sie haben bereits eine Authenticator-App? Dann k\u00f6nnen Sie diese verwenden.", "Already have an authenticator app? You can use that one.")}
      </p>
    </div>
  );
};
